import {
  ListStockItemsQuery,
  StockItem,
  StockOrderColumnConfig,
} from '@/core/domain/stock/StockItems/StockItems.types';
import { tableSorterOrder } from '@/utils/table';
import { SorterResult } from 'antd/lib/table/interface';

export default function partsOrderColumns(
  sorter: SorterResult<StockItem>,
  setQueryParams: React.Dispatch<React.SetStateAction<ListStockItemsQuery>>,
) {
  if (sorter && sorter?.columnKey) {
    setQueryParams((prev) => {
      if (sorter && sorter?.columnKey) {
        const order = sorter.order ? tableSorterOrder[sorter.order] : undefined;

        if (prev.orderColumns === StockOrderColumnConfig[sorter.columnKey]) {
          return {
            ...prev,
            order,
          };
        }

        return {
          ...prev,
          order: tableSorterOrder.ascend,
          orderColumns: StockOrderColumnConfig[sorter.columnKey],
        };
      }

      return prev;
    });
  }
}
